import type { GazeSample } from "../api/types";

/** A synthetic centre point is a recorder placeholder, not eye-tracking data. */
export function measuredGaze(sample: GazeSample) {
  return sample.valid && sample.synthetic === false && !sample.source?.startsWith("synthetic") &&
    sample.x != null && sample.y != null && Number.isFinite(sample.x) && Number.isFinite(sample.y) &&
    sample.x >= 0 && sample.x <= 1 && sample.y >= 0 && sample.y <= 1;
}

/** Subtract one typographic point (4/3 CSS px), independent of canvas resolution. */
export function objectCaptionFont(sourceWidth: number, sourcePixelsPerCssPixel: number) {
  return Math.max(1, Math.max(24, sourceWidth / 27) - (4/3) * sourcePixelsPerCssPixel);
}
